import { EnumUtil } from '@csp/csp-common-enum-util';
import { AppointmentLocationV1 } from '@csp/dmdp-api-appointment-dto';
import { VisitLocationType } from '../type/VisitLocationType';
import { VisitAddress } from './VisitAddress';

export type VisitLocation = {
  videoMeetingId?: string;
  locationType: VisitLocationType;
  locationRef?: string;
  address?: VisitAddress;
};

const from = ({ address, ref, type, video }: AppointmentLocationV1): VisitLocation => ({
  locationType: EnumUtil.fromMaybeStringOrDefault(type, VisitLocationType, VisitLocationType.UNKNOWN),
  address: address ? VisitAddress.from(address) : undefined,
  locationRef: ref,
  videoMeetingId: video?.meetingId,
});

export const VisitLocation = { from };
